import { AppTheme } from './types';

export const theme: AppTheme = {
  fonts: {
    uniCredit: 'UniCredit',
    arial: 'Arial, Helvetica, sans-serif',
  },
  lineHeights: {
    body: '1.5rem',
    h1: '3.125rem',
    h2: '2.625rem',
    h3: '1.375rem',
    h4: '1.5rem',
    h5: '0.963rem',
    h6: '0.791rem',
  },
  fontSizes: {
    body: '1.125rem',
    h1: '3.125rem',
    h2: '2.188rem',
    h3: '1.25rem',
    h4: '1.125rem',
    h5: '0.875rem',
    h6: '0.688rem',
  },
  colors: {
    primaryK11: '#909090',
    primaryK10: '#262626',
    primaryR1: '#E2001A',
    primaryK9: '#262626',
    primaryK8: '#F5F5F5',
    primaryK7: '#666666',
    primaryK5: '#F5F5F5',
    primaryK4: '#909090',
    primaryK3: '#CCCCCC',
    primaryK2: '#E5E5E5',
    primaryK1: '#F5F5F5',
    primaryW: '#FFFFFF',
    primaryT6: '#E7F8FB',
    primaryT5: '#007A91',
    primaryT4: '#E7F8FB',
    primaryT3: '#BFEBF3',
    primaryT2: '#007A91',
    primaryT1: '#006375',
    primaryG5: '#2E844D',
    primaryO5: '#F26B08',
    primaryR5: '#D73928',
    primaryB1: '#388BCA',
    primaryB2: '#004F95',
    primaryG7: '#004C3D',
    primaryG6: '#007A6B',
    primaryG4: '#899E00',
    primaryG8: '#546100',
    primaryO4: '#B8860B',
    primaryY4: '#E67300',
    primaryS9: '#DD1860',
    primaryP1: '#A33694',
    primaryP3: '#B381B3',
    primaryP2: '#7757A4',
    primaryS13: '#5E3D32',
    primaryS14: '#535453',
    positive: '#2e844d',
    warning: '#f26b08',
    negative: '#d73928',
    backdrop: '#00000073',
  },
  fontWeight: {
    thin: '400',
    normal: '500',
    bold: '600',
  },
};

export const darkTheme = {
  colors: {
    primaryK11: '#000000',
    primaryK10: '#FFFFFF',
    primaryR1: '#FFFFFF',
    primaryK9: '#000000',
    primaryK8: '#000000',
    primaryK7: '#FFFFFF',
    primaryK5: '#666666',
    primaryK4: '#FFFFFF',
    primaryK3: '#FFFFFF',
    primaryK2: '#FFFFFF',
    primaryK1: '#FFFFFF',
    primaryW: '#000000',
    primaryT6: '#000000',
    primaryT5: '#262626',
    primaryT4: '#FFFFFF',
    primaryT3: '#FFFFFF',
    primaryT2: '#FFFFFF',
    primaryT1: '#FFFFFF',
    primaryG5: '#FFFFFF',
    primaryO5: '#FFFFFF',
    primaryR5: '#FFFFFF',
    primaryB1: '#FFFFFF',
    primaryB2: '#FFFFFF',
    primaryG7: '#FFFFFF',
    primaryG6: '#FFFFFF',
    primaryG4: '#FFFFFF',
    primaryG8: '#FFFFFF',
    primaryO4: '#FFFFFF',
    primaryY4: '#FFFFFF',
    primaryS9: '#FFFFFF',
    primaryP1: '#FFFFFF',
    primaryP3: '#FFFFFF',
    primaryP2: '#FFFFFF',
    primaryS13: '#FFFFFF',
    primaryS14: '#FFFFFF',
    positive: '#FFFFFF',
    warning: '#FFFFFF',
    negative: '#FFFFFF',
    backdrop: '#FFFFFF',
  },
};